import { successRes, errorRes } from "../../utils.js";
export const getSystemData = async (self) => {
  try {
    const response = await fetch(
      self.props.host + "/getSD/" + self.props.userId
    );
    if (response.status !== 200) {
      return errorRes(
        "Looks like there was a problem. Status Code: " + response.status
      );
    }
    const res = await response.json();
    self.setState((state) => ({
      ...state,
      systemData: res.data,
    }));
    return successRes(res);
  } catch (err) {
    return errorRes("Fetch Error", err);
  }
};

export const setSystemData = async (data, self) => {
  let sd = self.state.systemData;
  sd = { ...sd, ...data };
  try {
    const response = await fetch(
      self.props.host + "/setSD/" + self.props.userId,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sd),
        credentials: "include",
      }
    );
    if (response.status !== 200) {
      return errorRes(
        "Looks like there was a problem. Status Code: " + response.status
      );
    }
    const res = await response.json();
    self.setState((state) => ({
      ...state,
      systemData: sd,
    }));
    return successRes(res);
  } catch (err) {
    return errorRes("Fetch Error", err);
  }
};
